export type AnimalEventStatus =
  | 'current'
  | 'inhome'
  | 'surrendered'
  | 'returned'
  | 'deceased'
  | 'default';

export interface AnimalEventStatusDisplay {
  readonly status: AnimalEventStatus;
  readonly label: string;
}

export function resolveAnimalEventStatus(
  value: string | null | undefined,
): AnimalEventStatusDisplay {
  const rawStatus = value?.trim() || '';

  const normalizedStatus = rawStatus.toLowerCase().replace(/[\s,_-]+/g, '');

  /*
   * Deceased takes precedence in compound values
   * such as "InHome, Deceased".
   */
  if (normalizedStatus.includes('deceased')) {
    return {
      status: 'deceased',
      label: 'Deceased',
    };
  }

  if (normalizedStatus.includes('surrender')) {
    return {
      status: 'surrendered',
      label: 'Surrendered',
    };
  }

  if (
    normalizedStatus.includes('returned') ||
    normalizedStatus.includes('return')
  ) {
    return {
      status: 'returned',
      label: 'Returned',
    };
  }

  if (normalizedStatus.includes('currentfoster')) {
    return {
      status: 'current',
      label: 'Current Foster',
    };
  }

  if (
    normalizedStatus.includes('inhome')
  ) {
    return {
      status: 'inhome',
      label: 'In Home',
    };
  }

  return {
    status: 'default',
    label: rawStatus || 'Current',
  };
}
